module.exports = __webpack_public_path__ + "img/pin-seller.17136a5d.svg";